import React, { useState, useEffect } from "react";
import { useLocation } from "@reach/router";

import DashboardIcon from "../../assets/images/Icons/admin/dashboard.svg";
import ManageJobsIcon from "../../assets/images/Icons/admin/mjobs.svg";
import NavItem from "../../utils/adminnav";

const SubNavbar = () => {
    const location = useLocation();
    const [activeItem, setActiveItem] = useState("");

    useEffect(() => {
        const currentPath = location.pathname;
        setActiveItem(currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath);
    }, [location.pathname]);

    const navbarItems = [
        {
            path: "/admin/hr-admin-dashboard",
            label: "Dashboard",
            icon: DashboardIcon,
        },
        {
            path: "/admin/list-of-all-jobs",
            label: "Manage Jobs",
            icon: ManageJobsIcon,
        },
        {
            path: "/admin/applicant-profiles",
            label: "Applicant Data",
            icon: ManageJobsIcon,
        },
    ];

    return (
        <div className="admin-sub-header">
            <div className="admin-navbar">
                {navbarItems.map((item) => (
                    <NavItem
                        key={item.path}
                        path={item.path}
                        label={item.label}
                        icon={item.icon}
                        isActive={activeItem === item.path}
                        onClick={() => setActiveItem(item.path)}
                    />
                ))}
            </div>
        </div>
    );
};

export default SubNavbar;
